import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { publicMethods, baseUrl } from '../globals';
import { AuthenticationService } from './authentication.service';

type MatcherType = 'Regular' | 'CRM';

@Injectable()
export class CompanyMatcherV2Service {
  constructor(
    private http: HttpClient,
    private pubMethods: publicMethods,
    private auth: AuthenticationService
  ) {}

  isLoading = {
    loadingData: false,
  };

  private readonly CRM_MATCHER_ROUTE = '/matcher/crm';
  private readonly SEARCH_REGULAR_MATCHER_DETAILS_ENDPOINT =
    '/search_regular_matcher_details/';

  private getCurrentPathname(): string {
    if (typeof window === 'undefined' || !window.location) {
      return '';
    }
    return window.location.pathname || '';
  }

  private getMatcherTypeFromRoute(
    pathname: string = this.getCurrentPathname()
  ): MatcherType {
    if (
      pathname === this.CRM_MATCHER_ROUTE ||
      pathname.startsWith(`${this.CRM_MATCHER_ROUTE}/`)
    ) {
      return 'CRM';
    }
    return 'Regular';
  }

  private shouldAttachMatcherType(endpoint: string): boolean {
    return (
      endpoint?.trim() === this.SEARCH_REGULAR_MATCHER_DETAILS_ENDPOINT
    );
  }

  searchMatchedData(
    endpoint,
    lowerMatchLevel,
    upperMatchLevel,
    pageNumber,
    resultsPerPage,
    isInit
  ): Observable<any> {
    let _params = new HttpParams()
      .set('lowerMatchLevel', lowerMatchLevel)
      .set('upperMatchLevel', upperMatchLevel)
      .set('pageNumber', pageNumber)
      .set('resultsPerPage', resultsPerPage)
      .set('isInit', isInit);
    if (this.shouldAttachMatcherType(endpoint)) {
      _params = _params.set('matcherType', this.getMatcherTypeFromRoute());
    }
    this.isLoading['loadingData'] = true;
    return this.http
      .post(baseUrl + endpoint, _params, this.auth.helperGetVerifiedPostDict())
      .pipe(
        tap(_ => (this.isLoading['loadingData'] = false)),
        catchError(
          this.pubMethods.handleError('searchMatchedData', [], this.isLoading)
        )
      );
  }
}
